import React from "react";

const YesilAlert = ({ onConfirm, onClose, message, hideButtons = false }) => {
  return (
    <div
      className="container fixed inset-0 flex items-center justify-center bg-whiteBg/80"
      onClick={onClose}
    >
      <div className="flex flex-col top-[322px] left-[475px]  w-[400px] h-[300px] rounded-lg p-4 gap-4 bg-whiteBg shadow-cardShadow hover:shadow-hoverShadow divide-y-2 divide-lineGray">
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="w-[360px] h-[110px]">
            <img
              src="/yesilalert.svg"
              alt="Yesil Alert"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-[326px] h-[50px] border-none gap-4 flex items-center justify-center">
            <h2 className="text-md text-grayy font-medium text-center">
              {message ? message : "Düzenlemeler başarıyla gerçekleştirildi !"}
            </h2>
          </div>
        </div>

        {!hideButtons && (
          <div className="flex items-center justify-center w-[326px] h-[40px] gap-4 pt-">
            <button
              onClick={onConfirm}
              className="text-center text-sm btn-green text-dark w-full h-[40px] rounded-lg p-[12px]  "
            >
              Evet
            </button>
            <button
              onClick={onClose}
              className="text-center  btn-dark text-sm text-white w-full h-[40px] rounded-lg p-[12px] "
            >
              Hayır
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default YesilAlert;
